const routes = {
  root: "/",
  campaigns: "/campaigns",
  blog: "/blog",
  pdfChat: "/free-chat-pdf",
  pdfChatAnonymous: "/free-chat-pdf/anonymous",
  pricing: "/plans",
  lists: "/lists",
  searches: "/search",
  findai: "/findai",
  tables: "/table",
  templates: "/marketplace/templates",
  templatesLanding: "/templates",
  table: (id: string) => `/table/${id}`,
  newTable: "/table/new",
  searchesDev: "/searches-dev",
  apiPlatform: "/platform",
  settings: "/settings",
  bookDemo: "/demo",
  admin: "/admin",
  msa: "/msa",
  invitationJoin: "/invitation/join",
  invitationAccept: "/invitation/accept",
  setupStatus: "/setup-status",
  learn: "/learn",
  academy: "/academy",

  apiPlatformOverview: "/api",
  apiSearch: "/api/search",
  apiCompany: "/api/company",
  apiPerson: "/api/person",
  signIn: "/login",
  sandbox: "/sandbox",
  notebook: "/notebook",
  signUp: "/sign_up",
  termsOfService: "/policies/terms",
  privacy: "/policies/privacy",
  footer: {
    caseStudies: "/case-studies",
    howTo: "/how-to",
    announcements: "/blog/new-features",
    topSearches: "/top-searches",
    recommendedSearches: "/recommended-searches",
    people: "/people",
    companies: "/companies",
    pro: "/plans",
    blog: "/blog",
  },
};

export { routes };
export default routes;
